import Plugin from 'lib/modulor/plugin'
import ScrollIntoView from 'lib/modulor/scroll_into_view'

export class Gallery extends Plugin
  @defaults =
    debug: false

  @selector: '.gallery'

  on_init: ->
    return unless @get_images().length > 1

    { default: Flickity } = await `import('plugins/flickity' /* webpackChunkName: "flickity" */)`

    if @is_flickity()
      @resize_flickity()
      return

    @flickity = new Flickity(@get_content()[0],
      cellAlign: 'left'
      cellSelector: '.gallery__image'
      contain: true
      initialIndex: @get_initial_index()
      lazyLoad: false
      pageDots: false
      prevNextButtons: true
      setGallerySize: false
    )

    @get_content().on 'select.flickity', (e) =>
      unless @is_being_removed()
        id = $(@flickity.selectedElement).find('.modulor_attachment').data('id')

        if @is_include_id_in_url()
          window.history.replaceState({}, null, window.location.pathname + '#' + id)

        $('.gallery__dots').trigger
          type: 'select_image'
          id: id
          ids: @get_image_ids()

    @$element.on "select_image.#{@options.name}", (e) =>
      id = e.attachment_image_id
      @select_image(id)
      ScrollIntoView.call(@$element) if @is_own_id(id)

    @select_image( @get_image_id_from_hash() || @get_first_image_id() )

  on_load: -> @resize_flickity()
  on_ready: -> @resize_flickity()
  on_turbolinks_render: -> @resize_flickity()

  on_destroy: ->
    @flickity.destroy() if @flickity
    @$element.off '.flickity'

  # this is not particularly clean way to check, if element is part of a page that is already being removed
  is_being_removed: -> @$element.closest('body').parent().length == 0
  is_flickity: -> @flickity != undefined
  is_own_id: (id) -> @get_image(id).length
  is_include_id_in_url: -> @$element.data('include-id-in-url') == true

  get_content: -> @$element.find('.gallery__content')
  get_first_image_id: -> @get_image_ids()[0]
  get_image: (id) -> @get_images().has("[data-id='#{id}']")
  get_image_ids: -> @get_images().map(-> $(this).find('.modulor_attachment').data('id')).toArray()
  get_images: -> @get_content().find('.gallery__image')
  get_image_id_from_hash: -> window.location.hash.replace('#', '')
  get_initial_index: ->
    return 0 unless @is_include_id_in_url()
    image_id_from_hash = @get_image_id_from_hash()
    return 0 unless !!image_id_from_hash
    return 0 unless image_id_from_hash in @get_image_ids()
    @get_image_ids().indexOf(image_id_from_hash)

  select_image: (id) ->
    return unless @is_own_id(id)
    $image = @get_image(id)
    index = $image.index()
    @flickity.select(index)

  resize_flickity: ->
    @flickity.resize() if @flickity

Gallery.register()
